import * as z from "zod";

// `namespace.key` lists exposed to the artifact; variant values override product.
export const customsMetafieldKeysSchema = z.object({
  product: z.array(z.string()),
  variant: z.array(z.string()),
});
export type CustomsMetafieldKeys = z.infer<typeof customsMetafieldKeysSchema>;

// Drives the redojs customs line-item augmentation. Distinct from the carrier
// customs-form defaults (CustomsSettings, under outboundLabels).
export const customsAugmentationSettingsSchema = z.object({
  // Extension artifact implementing `cross-border.customs.line-items`.
  artifactId: z.string().optional(),
  metafieldKeys: customsMetafieldKeysSchema.optional(),
});
export type CustomsAugmentationSettings = z.infer<
  typeof customsAugmentationSettingsSchema
>;
